<div class="sidebar included">
	<app-sidebar-header [title]="INDRA_getGroupLabel()"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<app-flight-route [flight]="flightRouteInput"></app-flight-route>
		<div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>

		<div class="sidebar__info--flight-info top-gap" *ngIf="!directFlight && stops.length">
			<p>{{ 'whatsIncludedSidebars.text.thisTripHas' | ibeadmin: 'sync' }} {{stops.length}} {{ 'whatsIncludedSidebars.text.flights' | ibeadmin: 'sync' }}. {{ 'whatsIncludedSidebars.detailsLounge.text.chooseForLoungeInfo' | ibeadmin: 'sync' }}</p>
			<app-segmented-control-radio classes="sidebar__info--flight-info--options" (selected)="INDRA_selectedStop($event)"
				[_value]="selectedStop" [options]="stops">
			</app-segmented-control-radio>
		</div>

		<div class="sidebar-flight-text">
			<ng-container *ngIf="INDRA_isEligibleWithLounge(), else noAncillary">
				<h2 class="title-h2">
					{{'whatsIncludedSidebars.detailsLounge.title.loungeAccessPerPassenger' | ibeadmin:'sync' }}
				</h2>
				<ng-container *ngFor="let statusCode of ancillaryCartService.INDRA_getAllWarnings(flight.idFlight.toString(), ancillaryGroup)">
					<app-notification [style]="'alert'" [close]="true" [icon]="'icons.svg#airport--delays'" [classes]="'alert-sidebar top-gap bottom-gap'"
					 [title]=" INDRA_getGroupLabel() + ' ' + ('whatsIncludedSidebars.general.texts.is' | ibeadmin:'sync')
					 + ' ' + (ancillaryCartService.INDRA_getStatusKey(statusCode)| ibeadmin:'sync') + ' ' + ('whatsIncludedSidebars.general.texts.inThisFlight' | ibeadmin:'sync')">
						<div message><span *ngIf="statusCode !== 46">{{'whatsIncludedSidebars.general.texts.useInAnotherFlight' | ibeadmin:'sync'}}</span>
							<a class="link" href="{{'whatsIncludedSidebars.general.texts.contactLink' | ibeadmin:'sync'}}" target="_blank" [attr.aria-label]="INDRA_getTranslation(INDRA_getTranslationKey('goRefund','aria')) | ibeadmin:'sync'">
								{{'whatsIncludedSidebars.general.texts.contactTap' | ibeadmin:'sync'}}
							</a>
							{{'whatsIncludedSidebars.general.texts.moreInfo' | ibeadmin:'sync'}}
						</div>
					</app-notification>
				</ng-container>
				
				<div *ngFor="let passenger of passengers" class="border sidebar-flight-text">
					<!-- fare related ancillaries for the passenger-->
					<div *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length > 0" class="grid no-padding">
						<div class="col-4 col-tp-4 col-p-12 no-padding">
							<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
						</div>
						<div class="col-8 col-tp-8 col-p-12">
							<p class="">
								<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" [alt]="'Checked icon'">
								</app-svg>
								<span class="bold">
									{{ INDRA_getTranslation(INDRA_getTranslationKey('at','title')) | ibeadmin:'sync' }}
									{{ departureLounge }}
									{{ INDRA_getTranslationKey('airport','title') | ibeadmin:'sync' }}
								</span>
								{{ INDRA_getTranslation(INDRA_getTranslationKey('includedIn','texts')) | ibeadmin:'sync' }} 
								<span class="capitalize">{{INDRA_printBrand()}}</span>.
							</p>
						</div>
					</div>
				
					<!-- tier benefits for the passenger-->
					<div *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length === 0 && INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax).length > 0" class="grid no-padding">
						<div class="col-4 col-tp-4 col-p-12 no-padding">
							<p class="bold" *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0">
								{{INDRA_printPassengerName(passenger)}}
							</p>
						</div>
						<div class="col-8 col-tp-8 col-p-12">
							<p class="">
								<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" [alt]="'Checked icon'">
								</app-svg>
								<span class="bold">
									{{ INDRA_getTranslationKey('at','title') | ibeadmin:'sync' }} {{INDRA_printDepartureLocation()}} {{ INDRA_getTranslationKey('airport','title') | ibeadmin:'sync' }}
								</span>
								{{ INDRA_getTranslationKey('isA','text') | ibeadmin:'sync' }} {{ INDRA_getPassengerTierLabel(passenger) }} {{ INDRA_getTranslationKey('benefit','text') | ibeadmin:'sync' }}.
							</p>
						</div>
					</div>
				
					<!-- purchased ancillaries for the passenger-->
					<div *ngFor="let item of INDRA_getPurchasedAncillaryForPassenger(passenger.idPax); let i = index;"
						class="grid no-padding">
						<div class="col-4 col-tp-4 col-p-12 no-padding">
							<p class="bold" *ngIf="i == 0 &&
								INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0 &&
								INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax).length == 0">
								{{INDRA_printPassengerName(passenger)}}
							</p>
						</div>
						<div class="col-8 col-tp-8 col-p-12">
							<p class="">
								<ng-container *ngIf="!item.unconfirmed">
									<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true"></app-svg>
								</ng-container>
								<ng-container *ngIf="item.unconfirmed">
									<app-svg class="list--checked__icon" svg="sprite.svg#status--alert" aria-hidden="true"></app-svg>
								</ng-container>
								<span class="bold">{{INDRA_displaySegmentDeparture(item?.segmentId)}}</span>
								<!-- <span *ngIf="hasLayover">{{INDRA_displaySegmentInfo(item.segmentId)}}</span> -->
							</p>
						</div>
					</div>
			
					<!-- no ancillaries for the passenger-->
					<div *ngIf="INDRA_getPurchasedAncillaryForPassenger(passenger.idPax).length == 0 && INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length === 0 && INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax).length === 0" class="grid no-padding">
						<div class="col-4 col-tp-4 col-p-12 no-padding">
							<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
						</div>
						<div class="col-8 col-tp-8 col-p-12">
							<p class="">{{ INDRA_getTranslationKey('notIncluded','texts') | ibeadmin:'sync' }}</p>
						</div>
					</div>
				</div>
			</ng-container>

			<!-- Lounge not included notificaion -->
			<ng-template #noAncillary>
				<div class="divider"></div>
				<div class="message_box">
					<app-svg svg="icons.svg#general--information" [alt]="'Information icon'" aria-hidden="true"></app-svg>
					<p>{{ 'whatsIncludedSidebars.detailsLounge.text.loungeNotAvailable' | ibeadmin: 'sync' }}</p>
				</div>
				<div class="divider"></div>
			</ng-template>
		</div>
		<div class="sidebar-flight-text border">
			<h2 class="title-h2" *ngIf="isEligibleFlag">{{ departureLounge }}
				{{'whatsIncludedSidebars.detailsLounge.title.airportLounge' | ibeadmin:'sync' }}</h2>
			<h2 class="title-h2" *ngIf="!isEligibleFlag">
				{{'whatsIncludedSidebars.detailsLounge.title.airportLounge' | ibeadmin:'sync' | titlecase }}</h2>
			<p class="muted">{{'whatsIncludedSidebars.detailsLounge.texts.enjoytheComfort' | ibeadmin:'sync' }}
				{{ departureLounge }}
				<span *ngIf="showFreeCharge">{{'whatsIncludedSidebars.detailsLounge.texts.airportFreeOfCharge' | ibeadmin:'sync' }}.</span></p>
			<p class="muted">{{'whatsIncludedSidebars.detailsLounge.texts.thereAreSomeThings' | ibeadmin:'sync' }}
			</p>
			<div class="grid">
				<div class="col-12">
					<ul>
						<li *ngFor="let items of loungeItems">{{items}}</li>
						
					</ul>
				</div>
			</div>
			<a (click)="INDRA_gotoURL('externalURLs.aboutLounge')"  href="javascript:;" class="link extras-feature__link link--external" [attr.aria-label]="'whatsIncludedSidebars.detailsLounge.aria.allAboutLounge' | ibeadmin:'sync'">
				{{'whatsIncludedSidebars.detailsLounge.title.allAboutLounge'| ibeadmin:'sync'}}
			</a>
		</div>
		<div class="sidebar-flight-text" *ngIf="!isBookingView && showAdd && !hasUMNRFlag">
			<button class="button " (click)="openLoungeSidebar()"
				[attr.aria-label]="'whatsIncludedSidebars.detailsLounge.aria.addLounge' | ibeadmin:'sync'">{{'whatsIncludedSidebars.detailsLounge.button.addLounge'| ibeadmin:'sync'}}
			</button>
		</div>
		<div class="sidebar-flight-text" *ngIf="!isBookingView && INDRA_showUpgrade()">
			<p>{{'whatsIncludedSidebars.detailsLounge.texts.FreeUpgradeToExclusive'| ibeadmin:'sync'}}</p>
			<button class="button "
				(click)="INDRA_upgradeWithCash()" [attr.aria-label]="'whatsIncludedSidebars.detailsLounge.aria.upgradeToExclusive' | ibeadmin:'sync'">{{'whatsIncludedSidebars.detailsLounge.button.upgradeToExclusive'| ibeadmin:'sync'}}
			</button>
		</div>
		<div class="sidebar-flight-text border" *ngIf="!hasAllFrequentFlyerPassenger">
			<h2 class="title-h2">{{'whatsIncludedSidebars.detailsLounge.title.tapMilesGo' | ibeadmin: 'sync'}}</h2>
			<p><a (click)="INDRA_gotoURL('externalURLs.aboutMilesAndGo')" href="javascript:;"
					class="link extras-feature__link link--external">{{'whatsIncludedSidebars.detailsLounge.title.allAbout' | ibeadmin:'sync'}}
					{{ 'whatsIncludedSidebars.detailsLounge.texts.milesGo' | ibeadmin:'sync' }}</a></p>
			<p>{{'whatsIncludedSidebars.detailsLounge.texts.notAMilesAndGo' | ibeadmin:'sync'}} <a href="#"
					class="link extras-feature__link"
					[attr.aria-label]="'whatsIncludedSidebars.detailsLounge.aria.signUp' | ibeadmin:'sync'">{{'whatsIncludedSidebars.detailsLounge.link.signUp' | ibeadmin:'sync'}}</a>
				{{'whatsIncludedSidebars.detailsLounge.texts.nowAndEarn' | ibeadmin:'sync'}}</p>
		</div>
		<div class="sidebar-flight-text border">
			<p><a class="link extras-feature__link"
					[attr.aria-label]="'whatsIncludedSidebars.detailsLounge.aria.closeDialog' | ibeadmin:'sync'"
					(click)="INDRA_handleClose()">{{'whatsIncludedSidebars.detailsLounge.link.closeThisWindow'| ibeadmin:'sync'}}</a>
			</p>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
